<template>
    <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.27273 4.13639L7.57102 4.84732L4.64418 1.92048L4.64418 9.50073L3.62855 9.50073L3.62855 1.92048L0.710937 4.84732L-2.34483e-07 4.13639L4.13636 2.17537e-05L8.27273 4.13639Z" fill="#FF5353"/>
    </svg>
</template>